/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './NavigationRpc';
import * as Queries from './NavigationRpc.dfc.new';
import type { AdditionalContextArgs } from './NavigationRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetNavigationManifestsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getNavigationManifests',
            References.GetNavigationManifestsResponseType
          >
        : References.GetNavigationManifestsResponseType)
    | undefined;
};

export function useGetNavigationManifestsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationManifestsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_NAVIGATION_MANIFESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNavigationManifests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNavigationManifestsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetNavigationManifestsQueryReturn<T>;
}

type UseGetNavigationManifestsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType,
    T extends true
      ? Record<
          'getNavigationManifests',
          References.GetNavigationManifestsResponseType
        >
      : References.GetNavigationManifestsResponseType
  >;

export function useGetNavigationManifestsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationManifestsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_NAVIGATION_MANIFESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNavigationManifests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetNavigationManifestsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetNavigationManifestsLazyQueryReturn<T>;
}

type UseGetNavigationManifestsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getNavigationManifests',
        References.GetNavigationManifestsResponseType
      >
    : References.GetNavigationManifestsResponseType;
};

export function useGetNavigationManifestsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetNavigationManifestsResponseType>,
    References.GetNavigationManifestsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationManifestsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_NAVIGATION_MANIFESTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getNavigationManifests: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNavigationManifestsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetNavigationManifestsSuspenseQueryReturn<T>;
}

type UseGetPortalNavigationQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getPortalNavigation',
            References.GetPortalNavigationResponseType
          >
        : References.GetPortalNavigationResponseType)
    | undefined;
};

export function useGetPortalNavigationQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalNavigationQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PORTAL_NAVIGATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalNavigation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalNavigationQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalNavigationQueryReturn<T>;
}

type UseGetPortalNavigationLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType,
    T extends true
      ? Record<
          'getPortalNavigation',
          References.GetPortalNavigationResponseType
        >
      : References.GetPortalNavigationResponseType
  >;

export function useGetPortalNavigationLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalNavigationLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PORTAL_NAVIGATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPortalNavigation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPortalNavigationLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPortalNavigationLazyQueryReturn<T>;
}

type UseGetPortalNavigationSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPortalNavigation', References.GetPortalNavigationResponseType>
    : References.GetPortalNavigationResponseType;
};

export function useGetPortalNavigationSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPortalNavigationResponseType>,
    References.GetPortalNavigationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPortalNavigationSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PORTAL_NAVIGATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPortalNavigation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPortalNavigationSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPortalNavigationSuspenseQueryReturn<T>;
}

type UseGetNavigationMenuQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getNavigationMenu', References.GetNavigationMenuResponseType>
        : References.GetNavigationMenuResponseType)
    | undefined;
};

export function useGetNavigationMenuQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationMenuQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_NAVIGATION_MENU_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNavigationMenu: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNavigationMenuQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetNavigationMenuQueryReturn<T>;
}

type UseGetNavigationMenuLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType,
    T extends true
      ? Record<'getNavigationMenu', References.GetNavigationMenuResponseType>
      : References.GetNavigationMenuResponseType
  >;

export function useGetNavigationMenuLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationMenuLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_NAVIGATION_MENU_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNavigationMenu: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetNavigationMenuLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetNavigationMenuLazyQueryReturn<T>;
}

type UseGetNavigationMenuSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getNavigationMenu', References.GetNavigationMenuResponseType>
    : References.GetNavigationMenuResponseType;
};

export function useGetNavigationMenuSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetNavigationMenuResponseType>,
    References.GetNavigationMenuRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNavigationMenuSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_NAVIGATION_MENU_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getNavigationMenu: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNavigationMenuSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetNavigationMenuSuspenseQueryReturn<T>;
}
